import styled from "styled-components";

import { menuItemsCss } from "../LinkCard/styles";

/** The period picked, as the search field beside it; its choices open under it, as a link's "⋯". */
export const Container = styled.div`
  position: relative;

  .toggle {
    display: flex;
    gap: 0.75rem;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 40px;
    padding: 0 12px;
    font-family: Inter, sans-serif;
    font-size: 0.875rem;
    color: var(--color-neutral-white);
    white-space: nowrap;
    background: var(--color-neutral-dark);
    border: 1px solid var(--color-neutral-base);
    border-radius: 10px;

    &:hover,
    &[aria-expanded="true"] {
      border-color: var(--color-neutral-light);
    }

    svg {
      flex-shrink: 0;
      color: var(--color-neutral-150);
      transition: transform 0.15s;
    }

    &[aria-expanded="true"] svg {
      transform: rotate(180deg);
    }
  }

  .items {
    ${menuItemsCss};

    /* the toggle is on the left of the screen: opening to the right keeps the longer choices ("Criados nos últimos 30 dias") inside it */
    right: auto;
    left: 0;
    min-width: 100%;
    max-width: calc(100vw - 32px);
  }
`;
